import { AppState } from 'src/app/store'

export const stockAlertListSelector = (state: AppState) => state.stockAlerts.list
export const deleteStockAlertSelector = (state: AppState) => state.stockAlerts.delete
export const createStockAlertSelector = (state: AppState) => state.stockAlerts.create
